import React from 'react'
import { BCard, BText, BTitle } from '@prague-digi/ui-components'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { ReduxState } from 'app-types'

import { contractSelectors, modalDialogActions, signingActions } from '../../redux'
import messages from '../../i18n'
import { PdfView, StickyFooter } from '../../components'
import { SigningType } from '../../constants/enums'
import { SMS_VERIFY } from '../../constants/modals'
import { intl, IntlInterface, wizard, WizardInterface } from '../../hoc'

interface StateToProps {
  contractPdf: string
}

interface DispatchToProps {
  setSigningType: Function
  showModalDialog: Function
}

type Props = WizardInterface & IntlInterface & StateToProps & DispatchToProps

interface LocalState {
  /** true if is document rendered */
  isDocumentRendered: boolean
  /** true if is document scrolled to the end */
  isReadingProgressDone: boolean
  /** flag indicates there action is in progress */
  processing: boolean
  /** reading progress 0-1 */
  readingProgress: number
}

export class Contract extends React.Component<Props, LocalState> {
  state: LocalState = {
    isReadingProgressDone: false,
    isDocumentRendered: false,
    processing: false,
    readingProgress: 0,
  }

  onloadSuccess = () => this.setState({ isDocumentRendered: true, readingProgress: 0 })

  setProgress = (value: number) =>
    this.setState({
      isReadingProgressDone: value >= 100,
      readingProgress: value / 100,
    })

  agree = () => {
    this.props.setSigningType(SigningType.Contract)
    this.props.showModalDialog(SMS_VERIFY)
  }

  render() {
    const { translate, contractPdf } = this.props
    const { readingProgress, isDocumentRendered, isReadingProgressDone } = this.state

    return (
      <>
        <BCard>
          <BTitle type="h3" theme="pb-0">
            {translate(messages.contract.title)}
          </BTitle>
          <BText theme="pb-1">{translate(messages.contract.perex)}</BText>

          <BText type="info" theme="pb-0 mb-0">
            <b>{translate(messages.contract.documents.product.title)}</b>
          </BText>
          <BText theme="pb-1">{translate(messages.contract.documents.product.text)}</BText>

          <BText type="info" theme="pb-0 mb-0">
            <b>{translate(messages.contract.documents.loan.title)}</b>
          </BText>
          <BText theme="pb-1">{translate(messages.contract.documents.loan.text)}</BText>
        </BCard>

        <PdfView
          endCoefficient={120}
          onPercentageChange={this.setProgress}
          onRenderedSuccess={this.onloadSuccess}
          pdfBase64Data={contractPdf}
          scale={1}
        />

        <StickyFooter
          disabled={!isDocumentRendered || !isReadingProgressDone}
          goNext={this.agree}
          goNextMsg={messages.contract.continue}
          readingProgress={readingProgress}
        />
      </>
    )
  }
}

export const mapStateToProps = (state: ReduxState): StateToProps => ({
  contractPdf: contractSelectors.getContractPdf(state),
})

export const mapDispatchToProps: DispatchToProps = {
  setSigningType: signingActions.setSigningType,
  showModalDialog: modalDialogActions.showModalDialog,
}

export const enhance = compose(intl, wizard, connect(mapStateToProps, mapDispatchToProps))

export default enhance(Contract)
